import _ from 'lodash'
import { HttpClient } from './HttpClient'

export type Tracker = {
  loading: boolean
  error: { code: string, message?: string } | null
}

export type BaseRequestAction = 'get' | 'list' | 'create' | 'update' | 'delete'

export type RequestTracker = Record<string, Tracker>

export interface CommonState {
  newlyCreatedItemId?: string
  requestTracker: RequestTracker
  search: {
    params: Record<string, any>
    result: Record<string, any>
  }
}

export class Model {

  commonState: CommonState
  httpClient: HttpClient
  modelName: string
  reducerName: string

  constructor(modelName: string, httpClient?: HttpClient) {
    this.commonState = {
      requestTracker: _.reduce(
        ['get', 'list', 'create', 'update', 'delete'],
        (tracker: RequestTracker, requestAction: string) => {
          tracker[requestAction] = {
            error: null,
            loading: false
          }
          return tracker
        },
        {} as RequestTracker
      ),
      search: {
        params: {},
        result: {}
      }
    }
    this.httpClient = httpClient || new HttpClient()
    this.modelName = modelName
    this.reducerName = modelName
  }

  getInitialState() {
    return this.commonState
  }
}